import { isNotEmpty } from '../../../../../../aos-helpers/src/helpers/FormValidation'
import { TaskTemplate } from '../task'
import { RefuellingTask, RefuellingTaskType } from '../task/RefuellingTask'
import { TaskType } from '../TaskType'
import {
    BaseTaskFormPayload,
    baseTaskFormPayloadFromTask,
    BaseTaskPayloadValidation,
    baseValidateTask,
    initialBaseTaskPayload,
} from './BaseTaskFormPayload'

export interface RefuellingTaskFormPayload extends BaseTaskFormPayload {
    type: TaskType.Refuelling
    refuellingTaskType?: RefuellingTaskType
    airplaneType?: string
    vehicleDetails?: string
}

export const refuellingTaskFormPayloadFromTask = (
    t: RefuellingTask | TaskTemplate<RefuellingTask>,
    isClone = false,
): RefuellingTaskFormPayload => ({
    type: TaskType.Refuelling,
    refuellingTaskType: t.refuellingTaskType,
    airplaneType: t.airplaneType,
    vehicleDetails: t.vehicleDetails,
    ...baseTaskFormPayloadFromTask(t, isClone),
})

export interface RefuellingTaskPayloadValidation extends BaseTaskPayloadValidation {
    type: TaskType
    refuellingTaskType: boolean
}

export const validateRefuellingTask = (t: RefuellingTaskFormPayload) => ({
    ...baseValidateTask(t),
    refuellingTaskType: isNotEmpty(t.refuellingTaskType),
})

export const initialRefuellingTaskPayload: RefuellingTaskFormPayload = {
    type: TaskType.Refuelling,
    ...initialBaseTaskPayload,
}
